<template>
  <div class="main-nav">
    <el-menu v-if="!isMobile" mode="horizontal" :default-active="activeMenu" class="desktop-menu"
      @select="handleSelect">
      <el-menu-item index="/">{{ $t('home') }}</el-menu-item>
      <!-- <el-menu-item index="/news">news</el-menu-item> -->
      <el-submenu index="1">
        <template slot="title">{{ $t('aboutConference') }}</template>
        <el-menu-item index="/aboutConference/background">{{ $t('background') }}</el-menu-item>
        <el-menu-item index="/aboutConference/charter">{{ $t('charter') }}</el-menu-item>
        <el-menu-item index="/aboutConference/committee">{{ $t('committee') }}</el-menu-item>
        <el-menu-item index="/aboutConference/experts">{{ $t('experts') }}</el-menu-item>
        <el-menu-item index="/aboutConference/contact">{{ $t('contact') }}</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">{{ $t('newsCenter') }}</template>
        <el-menu-item index="/news/announcements">{{ $t('announcements') }}</el-menu-item>
        <el-menu-item index="/news/info">{{ $t('info') }}</el-menu-item>
        <el-menu-item index="/news/future">{{ $t('future') }}</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">{{ $t('events') }}</template>
        <el-menu-item index="/events/currentEvents/0">{{ $t('currentEvents') }}</el-menu-item>
         <el-menu-item index="/events/pastEvents">{{ $t('pastEvents') }}</el-menu-item>
        <el-menu-item index="/events/otherEvents">{{ $t('otherEvents') }}</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">{{ $t('members') }}</template>
        <el-menu-item index="/members/aboutMembers">{{ $t('aboutMembers') }}</el-menu-item>
        <el-menu-item index="/members/joinMembers">{{ $t('joinMembers') }}</el-menu-item>
        <el-menu-item index="/members/introCommitee">{{ $t('introCommitee') }}</el-menu-item>
        <el-menu-item index="/partners/intro">{{ $t('partnerIntro') }}</el-menu-item>
      </el-submenu>
      <el-menu-item index="/careerCompetition">{{ $t('careerCompetition') }}</el-menu-item>
      <el-submenu index="5">
        <template slot="title">{{ $t('results') }}</template>
        <el-menu-item index="/result/influenceIndex">{{ $t('influenceIndex') }}</el-menu-item>
        <el-menu-item index="/result/exemplaryInstitutions">{{ $t('exemplaryInstitutions') }}</el-menu-item>
        <el-menu-item index="/result/exemplaryProject">{{ $t('exemplaryProject') }}</el-menu-item>
        <el-menu-item index="/result/outstandingCases">{{ $t('outstandingCases') }}</el-menu-item>
        <el-menu-item index="/result/notableContributions">{{ $t('notableContributions') }}</el-menu-item>
        <el-menu-item index="/result/distinguishedEducators">{{ $t('distinguishedEducators') }}</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="/results">{{$t('results')}}</el-menu-item> -->
      <el-menu-item @click.native="handleExternalNavigation" class="external-nav-item">
        {{ $t('vocEdMap') }}
      </el-menu-item>
      <el-menu-item index="/contact">{{ $t('contact') }}</el-menu-item>
      <div class="login-container">
        <el-submenu v-if="isLoggedIn" index="6">
          <template slot="title">{{ $t('userCenter') }}</template>
          <el-menu-item index="/user/profile">{{ $t('profile') }}</el-menu-item>
          <el-menu-item index="/user/myEvents">{{ $t('registrations') }}</el-menu-item>
          <el-menu-item index="/user/security">{{ $t('security') }}</el-menu-item>
          <el-menu-item @click="userLogout">{{ $t('logout') }}</el-menu-item>
        </el-submenu>
        <el-menu-item v-else index="/user/login" class="login-item">{{ $t('login') }}</el-menu-item>
      </div>
    </el-menu>

    <button v-if="isMobile" class="hamburger-menu" @click="toggleMenu">☰</button>
    <div v-if="isMobile && isMenuOpen" class="menu-overlay" @click="closeMenu"></div>
    <transition name="mobile-menu">
      <el-menu v-if="isMobile && isMenuOpen" mode="vertical" class="mobile-menu" @select="handleSelect">
        <el-menu-item index="/">{{ $t('home') }}</el-menu-item>
        <el-submenu index="1">
          <template slot="title">{{ $t('aboutConference') }}</template>
          <el-menu-item index="/aboutConference/background">{{ $t('background') }}</el-menu-item>
          <el-menu-item index="/aboutConference/charter">{{ $t('charter') }}</el-menu-item>
          <el-menu-item index="/aboutConference/committee">{{ $t('committee') }}</el-menu-item>
          <el-menu-item index="/aboutConference/experts">{{ $t('experts') }}</el-menu-item>
          <el-menu-item index="/aboutConference/contact">{{ $t('contact') }}</el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">{{ $t('newsCenter') }}</template>
          <el-menu-item index="/news/announcements">{{ $t('announcements') }}</el-menu-item>
          <el-menu-item index="/news/info">{{ $t('info') }}</el-menu-item>
          <el-menu-item index="/news/future">{{ $t('future') }}</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">{{ $t('events') }}</template>
          <el-menu-item index="/events/pastEvents">{{ $t('pastEvents') }}</el-menu-item>
          <el-menu-item index="/events/currentEvents/0">{{ $t('currentEvents') }}</el-menu-item>
          <!-- <el-menu-item index="/events/eduPlusEvents">{{$t('eduPlusEvents')}}</el-menu-item> -->
          <el-menu-item index="/events/otherEvents">{{ $t('otherEvents') }}</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">{{ $t('members') }}</template>
          <el-menu-item index="/members/aboutMembers">{{ $t('aboutMembers') }}</el-menu-item>
          <el-menu-item index="/members/joinMembers">{{ $t('joinMembers') }}</el-menu-item>
          <el-menu-item index="/partners/intro">{{ $t('partnerIntro') }}</el-menu-item>
        </el-submenu>
        <el-menu-item index="/careerCompetition">{{ $t('careerCompetition') }}</el-menu-item>
        <el-submenu index="5">
          <template slot="title">{{ $t('results') }}</template>
          <el-menu-item index="/result/influenceIndex">{{ $t('influenceIndex') }}</el-menu-item>
          <el-menu-item index="/result/exemplaryInstitutions">{{ $t('exemplaryInstitutions') }}</el-menu-item>
          <el-menu-item index="/result/exemplaryProject">{{ $t('exemplaryProject') }}</el-menu-item>
          <el-menu-item index="/result/outstandingCases">{{ $t('outstandingCases') }}</el-menu-item>
          <el-menu-item index="/result/notableContributions">{{ $t('notableContributions') }}</el-menu-item>
          <el-menu-item index="/result/distinguishedEducators">{{ $t('distinguishedEducators') }}</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="/results">{{$t('results')}}</el-menu-item> -->
        <el-menu-item @click.native="handleExternalNavigation" class="external-nav-item">
          {{ $t('vocEdMap') }}
        </el-menu-item>

        <el-menu-item index="/contact">{{ $t('contact') }}</el-menu-item>
        <el-submenu v-if="isLoggedIn" index="6">
          <template slot="title">{{ $t('userCenter') }}</template>
          <el-menu-item index="/user/profile">{{ $t('profile') }}</el-menu-item>
          <el-menu-item index="/user/myEvents">{{ $t('registrations') }}</el-menu-item>
          <el-menu-item index="/user/security">{{ $t('security') }}</el-menu-item>
          <el-menu-item @click="userLogout">{{ $t('logout') }}</el-menu-item>
        </el-submenu>
        <el-menu-item v-else index="/user/login" class="login-item">{{ $t('login') }}</el-menu-item>
      </el-menu>
    </transition>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      activeMenu: this.$route.path,
      realPath: this.$route.path,
      isMenuOpen: true,
      isMobile: false
    };
  },
  computed: {
    ...mapState(['token']),
    isLoggedIn() {
      return !!this.token;
    },

  },
  watch: {
    '$route.path': function (newPath) {
      const route = this.$route;
      this.activeMenu = route.meta?.activeMenu || newPath;

      console.log('activeMenu', this.activeMenu);
      if (this.activeMenu.indexOf('/column') === 0) {
        this.activeMenu = '/news/info';
      } else if (this.activeMenu.indexOf('/news/detail') === 0) {
        let t = this.$route.query.t;
        if (t == 1) {
          this.activeMenu = '/news/announcements';
        } else if (t == 2) {
          this.activeMenu = '/news/info';
        } else {
          this.activeMenu = '/news/future';
        }
      }
      if (this.activeMenu.indexOf('/events/currentEvents/0') === 0) {
        this.activeMenu = '/events/currentEvents/0';
      } else if (this.activeMenu.indexOf('/events/currentEvents') === 0) {
        this.activeMenu = '/events/pastEvents';
      } else if (this.activeMenu.indexOf('/competition/detail') === 0) {
        this.activeMenu = '/careerCompetition';
      }
    }
  },
  mounted() {
    this.checkMobile();
    if (this.isMobile) {
      this.isMenuOpen = false;
    }
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    ...mapActions(['Logout']),
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      console.log('toggleMenu', this.isMenuOpen)
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleSelect(key) {
      console.log('handleSelect', key)

      if (key && key !== this.$route.path) {
        // 只有当key是一个路由路径时才进行路由跳转
        if (key.startsWith('/')) {
          this.$router.push(key).then(() => {
            // 路由跳转成功后再关闭菜单，避免闪烁问题
            if (this.isMobile) {
              setTimeout(() => {
                this.isMenuOpen = false;
              }, 100);
            }
          }).catch(err => {
            console.error('路由跳转错误:', err);
          });
        }
      }
    },
    handleExternalNavigation() {
      // this.$message.success('敬请期待');
      this.$router.push('/vocEdMap');

      // const newWindow = window.open('https://www.baidu.com', '_blank');
      // newWindow.opener = null;
    },
    userLogout() {
      this.Logout().then(() => {
        // 退出后刷新页面
        // window.location.reload();
        this.$router.replace('/');
      });
    }
  }
};
</script>

<style>
.el-menu.el-menu--popup.el-menu--popup-bottom-start {
  min-width: 7.2rem !important;
  /* 使用 !important 覆盖默认样式 */
}

.external-nav-item {
  position: relative;
  transition: all 0.3s ease;


  &:hover {
    background-color: #f0faff;

  }
}

.main-nav {
  box-sizing: border-box;

  justify-content: space-between;
  align-items: center;

}

@media (max-width: 768px) {
  .main-nav {
    width: 100%;
    margin: 0;
    padding: 0 15px;
  }
  
}

.desktop-menu {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  margin: 0;
  height: 48px;

  .el-menu-item {
    padding: 0 20px !important;
  }
}

.login-container {
  margin-left: auto;
  display: flex;
  align-items: center;
  position: relative;
  top: 0;

  .el-submenu.is-active .el-submenu__title{
    color: black !important;
    font-weight: bold !important;
  }
  .el-submenu__title {
    font-size: var(--text-base) !important;
    color: #909399 !important;

    &:hover,
    &:focus {
      background-color: transparent !important;
      color: black !important;
      font-weight: bold !important;
    }

    &.is-active {
      background-color: transparent !important;
      color: black !important;
      font-weight: bold !important;
    }
  }
}

.login-item {
  margin-left: 0;
  padding: 0 20px;
  color: #909399 !important;
  font-size: var(--text-base) !important;
  background-color: transparent !important;

  &:hover,
  &:focus {
    background-color: transparent !important;
    color: black !important;
    font-weight: bold !important;
  }

  &.is-active {
    background-color: transparent !important;
    color: black !important;
    font-weight: bold !important;
  }
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: none !important;
  color: black !important;
  font-weight: bold !important;
}

.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
  color: black !important;
  font-weight: bold !important;
}

@media (max-width: 768px) {
  .main-nav {
    display: block;
    position: relative;
  }


  .desktop-menu {
    display: none;
  }

  .hamburger-menu {
    display: none;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 10px;
    left: 0.375rem;
    top: 0.375rem;
    z-index: 2001;
    color: #333;
    margin-top: 0;

    @media (max-width: 768px) {
      display: block;
    }
  }
}

.el-menu--horizontal {
  border-bottom: solid 0.15rem black !important;
  height: 48px !important;
}

.el-menu--horizontal>.el-menu-item,
.el-menu--horizontal>.el-submenu .el-submenu__title {
  text-align: center;
  font-size: var(--text-base) !important;
  height: 48px !important;
  line-height: 48px !important;
}

.el-menu--popup .el-menu-item {
  text-align: center;
  font-size: var(--text-sm) !important;
  height: 40px;
  line-height: 40px;
}


.el-submenu__icon-arrow {
  display: none !important;
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.mobile-menu {
  position: fixed !important;
  top: 1.5rem;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 10px 0;
  /* height: calc(100vh - 48px); */
  overflow-y: auto;
  transform-origin: top;
  width: 120px;
}

.mobile-menu .el-menu {
  margin-left: 48px !important;
}

.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.mobile-menu-enter,
.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.mobile-menu .el-menu-item,
.mobile-menu .el-submenu .el-submenu__title {
  font-size: var(--text-sm) !important;
  height: 48px;
  line-height: 48px;
  padding: 0 20px !important;
}

.mobile-menu .el-submenu .el-menu {
  background-color: #f5f7fa;
  padding: 5px 0;
  margin-left: 0 !important;
}

.mobile-menu .el-submenu .el-menu-item {
  min-width: auto;
}
</style>